<template>
    <div data-app>
        <v-dialog v-model="dialog" persistent max-width="350">
            <v-card>
                <v-card-title class="headline">
                    Emin misiniz?
                </v-card-title>
                <v-card-text
                    >Silmek istediğiniz kayıt kalıcı olarak silinecektir. Bu
                    kaydı silmek istediğinize emin misiniz?</v-card-text
                >
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="text-danger" text @click="dialog = false">
                        Hayır
                    </v-btn>
                    <v-btn class="text-success" text @click="deleteMember()">
                        Evet
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <div>
            <v-data-table
                :headers="headers"
                :items="paginateAllMembers"
                no-results-text="Herhangi bir sonuç bulunamadı..."
                disable-pagination
                :hide-default-footer="true"
                :server-items-length="meta_member.total"
                @update:options="sort"
            >
                <template v-slot:top>
                    <v-toolbar flat>
                        <v-toolbar-title>Eski Üyeler</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-col sm="1">
                            <b-form-select 
                                v-model="pageSize" 
                                :options="pageSizes" 
                                @change="handlePageSizeChange"
                            ></b-form-select>
                        </v-col>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        {{ meta_member.total }} kayıt
                        <v-divider class="mx-4" inset vertical></v-divider>
                        {{ meta_member.from }} - {{ meta_member.to }}
                        <v-divider class="mx-4" inset vertical></v-divider>
                        
                        <b-button
                            v-if="hasPermission('members.create')"
                            size="sm"
                            variant="primary"
                            @click="addMember()"
                        >
                            YENİ KAYIT
                        <i class="la la-plus"></i>
                        </b-button>

                        <v-spacer></v-spacer>
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Araştır"
                            single-line
                            hide-details
                            @input="searchTable"
                        ></v-text-field>
                    </v-toolbar>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <div class="m-demo__preview m-demo__preview--btn">
                        <v-icon
                            class="la la-eye"
                            data-toggle="m-popover" title="Görüntüle"
                            @click="viewMember(item.id)"
                        >
                        </v-icon>
        
                        <v-icon v-if="hasPermission('members.update')"
                            class="la la-edit"
                            data-toggle="m-popover" title="Güncelle"
                            @click="editMember(item.id)"
                        >
                        </v-icon>

                        <v-icon v-if="hasPermission('members.delete')"
                            class="la la-trash"
                            data-toggle="m-popover" title="Sil"
                            @click="showDeleteDialog(item.id)"
                        >
                        </v-icon>

                        
                    </div>    
                </template>

                <template v-slot:[`item.is_active`]="{item}">
                    <b-badge class="mr-1" :variant="getClass(item.is_active)">{{ getText(item.is_active) }}</b-badge>
                </template>
                

                <template v-slot:[`item.created_at`]="{ item }">
                    <span>{{ item.created_at | formatDateTime }}</span>
                </template>
                <template v-slot:[`item.updated_at`]="{ item }">
                    <span>{{ item.updated_at | formatDateTime }}</span>
                </template>


                <template v-slot:footer>
                    <v-toolbar flat>
                        <template>
                            <v-row>
                                <v-col cols="12" sm="12">
                                    <b-pagination
                                        v-model="page"
                                        :total-rows="meta_member.total"
                                        :per-page="itemsPerPage"
                                        size="lg"
                                        @input="handlePageChange"
                                        align="right"
                                        first-number
                                        last-number
                                    ></b-pagination>
                                </v-col>
                            </v-row>
                        </template>
                    </v-toolbar>
                </template>
            
            </v-data-table>
        </div>
        
        <br />
        <div class="text-center">
            <b-spinner
                variant="primary"
                type="grow"
                label="Spinning"
                v-if="loading"
            ></b-spinner>
        </div>
          
    </div>
    
</template>

<script>

import { mapGetters } from 'vuex';
import { mapState } from 'vuex';
import { PAGINATE_ALL_MEMBERS } from "@/core/services/store/members.module";
import { DELETE_MEMBER } from "@/core/services/store/members.module";

export default {
    name: "members-list",
    data() {
        return {
            title: "",
            search: "",
            dialog: false,
            itemToDelete: "",
            page: 1,
            itemsPerPage: 10,
            pageSize: 10,
            pageSizes: [10, 25, 50, 100],
            totalPages: 0,
            currentPage: 1,
            total: 0,
            from: 0, 
            to: 0,
            sortBy: 'updated_at',
            sortDesc: true,
            timer: null,
            row: false,
            headers: [
                { text: "İşlemler", value: "actions", sortable: false },
                { text: "ID", align: "start", value: "id" },
                { text: "Üye İsmi", align: "start", value: "name" },
                { text: "Üye No", align: "start", value: "member_no" },
                { text: "Telefon No", align: "start", value: "mobile_phone" },
                { text: "Bakiye", align: "start", value: "balance" },
                { text: "Üyelik Tarihi", align: "start", value: "membership_date" },
                { text: "Statü", align: "start", value: "status" },
            ],
        };
    },

    methods: {
        handlePageChange(value) {
            this.currentPage = value;
            this.paginate();
        },

        searchTable(value){
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                this.search = value;
                this.paginate();
            }, 500);
        },

        sort(options){
            this.sortBy = options.sortBy;
            this.sortDesc = options.sortDesc;
            this.paginate();
        },

        handlePageSizeChange(size) {
            this.pageSize = size;
            this.itemsPerPage = size;
            this.page = 1;
            this.paginate();
        },
        
        showDeleteDialog(id) {
            this.itemToDelete = id
            this.dialog = !this.dialog
        },

        addMember() {
            this.$router.push({
                name: "members-form",
                params: { formType: "add"}
            });
        },

        editMember(id) {
            this.$router.push({
                name: "members-form",
                params: { id: id, formType: "edit" }
            });
        },

        viewMember(id) {
            this.$router.push({
                name: "members-form",
                params: { id: id, formType: "view" }
            });
        },
        
        deleteMember() {
            this.dialog = false;
            
            var itemToDelete = this.itemToDelete;
            this.$store.dispatch(DELETE_MEMBER, {
                    itemToDelete
                });
            this.paginate();
        },
        paginate() {
            var pageNumber = this.page;
            var itemsPerPage = this.itemsPerPage;
            var sortBy = this.sortBy;  
            var sortDesc = this.sortDesc; 
            var search = this.search;
            var x = 1;

            this.$store.dispatch(PAGINATE_ALL_MEMBERS, {
                    itemsPerPage, 
                    pageNumber, 
                    sortBy, 
                    sortDesc, 
                    search,
                    x
                });
            },

        hasPermission(permission) {
            return this.currentUserMenu.permissions.some(function(el) {
                return el.name === permission;
            }); 
        },
        
        getClass(id) {
            if (id == 1) return 'primary'
            else return 'secondary'
        },

        getText(id) {
            if (id == 1) return 'Aktif'
            else return 'Pasif'
        }
        
        },
    created(){
        this.$store.dispatch('getUserMenu');
        
    },
   
    computed: {
        
        ...mapGetters(["paginateAllMembers", "meta_member", "currentUserMenu"]),
        
        ...mapState({
            loading: state => state.members.loading,
        }),
        
    },

};
</script>
